import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../state/store";
import { fetchPerformanceTableData } from "./performanceTableAPI";

export interface TableState {
  data: any[];
  loading: boolean;
  error: string | null;
  toggle: string;
}

const initialState: TableState = {
  data: [],
  loading: false,
  error: null,
  toggle: "INTERNAL",
};

export const fetchPerformanceTableDataThunk = createAsyncThunk<any[], any>(
  "table/fetchTableData",
  async (payload: any, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const toggle = state.performanceTable.toggle;
    const response = await fetchPerformanceTableData(payload, toggle);

    return response;
  }
);

const performanceTableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    setToggle: (state, action) => {
      state.toggle = action.payload;
    },
    resetPerformanceTableState: () => {
      return initialState;
    },
    setPerformanceTableDataEmpty: (state) => {
      state.data = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPerformanceTableDataThunk.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = null;
    });
    builder.addCase(
      fetchPerformanceTableDataThunk.fulfilled,
      (state, action) => {
        state.loading = false;

        state.data = action.payload;
      }
    );
    builder.addCase(
      fetchPerformanceTableDataThunk.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch data";
      }
    );
  },
});

export const {
  setToggle,
  resetPerformanceTableState,
  setPerformanceTableDataEmpty,
} = performanceTableSlice.actions;

export const selectTableData = (state: RootState) =>
  state.performanceTable.data;
export const selectTableLoading = (state: RootState) =>
  state.performanceTable.loading;
export const selectTableError = (state: RootState) =>
  state.performanceTable.error;
export const selectTableToggle = (state: RootState) =>
  state.performanceTable.toggle;

export default performanceTableSlice.reducer;
